
import { defineComponent, h, useCssModule } from 'vue';

import { slotSeeker } from '@/utils';

export default defineComponent({
  name: 'PanelmenuNavbarSlotRight',
  render() {
    const $style = useCssModule();

    return h('f7-nav-right', { class: $style.navRight }, [
      slotSeeker('panelmenu-navbar-slot-right'),
      this.$slots.default,
    ]);
  },
});
